import 'regenerator-runtime/runtime';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { reportError } from 'src/utils';
import services from 'src/services';

const reducer = combineReducers(
  Object.keys(services).reduce((prev, key) => services[key].reducer ? {
    ...prev,
    [key]: services[key].reducer,
  } : prev, {})
);

const preloadedState = Object.keys(services).reduce((prev, key) => ({
  ...prev,
  [key]: services[key].flows.getInitialState(),
}), {});

const sagaMiddleware = createSagaMiddleware({
  onError: (error, { sagaStack }) => reportError(error, sagaStack),
});
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = [sagaMiddleware];

const store = createStore(
  reducer,
  preloadedState,
  composeEnhancer(
    applyMiddleware(
      ...middlewares
    ),
  )
);

Object.keys(services).forEach(key => {
  if (services[key].sagas) {
    sagaMiddleware.run(services[key].sagas);
  }
});

export default store;
